<template>
    <button
      :type="type"
      :class="classes"
      :disabled="disabled || isLoading"
      @click="handleClick"
    >
      <span v-if="isLoading">{{ loadingText }}</span>
      <span v-else><slot /></span>
      <i v-if="isLoading" class="fas fa-spinner fa-spin"></i>
    </button>
  </template>
  
  <script>
  export default {
    name: "AsyncButton",
    props: {
      action: { type: Function, required: true },
      type: { type: String, default: "button" },
      classes: { type: [String, Array, Object], default: "" },
      disabled: { type: Boolean, default: false },
      loadingText: { type: String, default: "Saving..." }
    },
    data() {
      return {
        isLoading: false
      };
    },
    methods: {
      async handleClick(e) {
        if (this.isLoading || this.disabled) return;
  
        this.isLoading = true;
  
        try {
          await this.action(e);
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoading = false;
        }
      }
    }
  };
  </script>
  